export default __webpack_public_path__ + "static/media/timeline-empty.12e456da.svg";